import React from 'react'
import UploadFile from './upload-file'
import { CONST_GOOGLE_SHEET_IDS } from '../../../../constants'

const CommercialImport = ({ onUploadFile }) => {
	return (
		<div className=' max-w-96  mx-auto'>
			<div className=' dark:text-white font-semibold text-xl  text-center justify-center items-center p-4'>
				UPLOAD LEADS FILE (xlsx)
			</div>
			<UploadFile
				sheetId={CONST_GOOGLE_SHEET_IDS.MX_COMMERCIAL_LEADS}
				onUploadFile={onUploadFile}
			/>

			<div className=' dark:text-white font-semibold text-xl  text-center justify-center items-center p-4 mt-4'>
				UPLOAD PROJECTS FILE (xlsx)
			</div>
			<UploadFile
				sheetId={CONST_GOOGLE_SHEET_IDS.MX_COMMERCIAL_PROJECTS}
				onUploadFile={onUploadFile}
			/>
		</div>
	)
}

export default CommercialImport
